"use client"

import React, { useContext } from "react"

import AppContext from "../AppContext"

interface BioModalTriggerProps extends React.HTMLAttributes<HTMLButtonElement> {
  modalOpen: boolean
  name?: string
  title?: string
  bio?: string
  company?: string
  linkedin?: string
  lightmode?: boolean
}

const BioModalTrigger: React.FC<BioModalTriggerProps> = ({
  modalOpen,
  name = "",
  title = "",
  bio = "",
  company = "",
  linkedin = "",
  lightmode = false,
  children,
  ...props
}) => {
  const context = useContext(AppContext)

  return (
    <button
      type="button"
      {...props}
      onClick={() =>
        context.setBioModal(
          modalOpen,
          name,
          title,
          bio,
          company,
          linkedin,
          lightmode,
        )
      }
    >
      {children}
    </button>
  )
}

export default BioModalTrigger
